import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import styles from './ProhibitedNotice.module.css';
function ProhibitedNotice() {
  const $ = _c(12);
  const t = useTranslations("nextjs.donate");
  let t0;
  if ($[0] !== t) {
    t0 = t("prohibited_headline");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="donate-iframe-header"><div className="donate-iframe-headline"><p className="line1">{t0}</p></div></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames("max-w-screen-xs", styles.prohibitedNoticeText);
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("prohibited_notice");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="donate-iframe-content"><div className={t2}>{t3}</div></div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <>{t1}{t4}</>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export default ProhibitedNotice;